// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"e83d551a","348":"4ea3e38b"}[chunkId] + ".chunk.css";
};